import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface VoteResult {
  voteScore: number;
  myVote: number | null;
}

@Injectable({
  providedIn: 'root'
})
export class VoteService {

  constructor(private httpClient: HttpClient) { }

  castVote(productId: string, value: 1 | -1): Observable<VoteResult> {
    const host = environment.host;
    return this.httpClient.post<VoteResult>(host + '/votes', { productId, value });
  }

  getMyVote(productId: string): Observable<{ myVote: number | null }> {
    const host = environment.host;
    return this.httpClient.get<{ myVote: number | null }>(host + '/votes/mine/' + productId);
  }

  getMyVotesForProducts(productIds: string[]): Observable<{ [productId: string]: number }> {
    const host = environment.host;
    return this.httpClient.post<{ [productId: string]: number }>(host + '/votes/mine', { productIds });
  }
}
